import { Grid, Typography, Button, Box } from '@mui/material';
import { Header } from 'components/Header/Header';
import { useState, useEffect } from 'react';
import Editor from 'react-simple-wysiwyg';
import { EditorService } from 'Helpers/EditorService';

export const BackofficeTermsPolicies = () => {
  const [content, setContent] = useState({
    terms: '',
    privacy: '',
  });
  const [editing, setEditing] = useState({
    terms: false,
    privacy: false,
  });
  const [loading, setLoading] = useState(true);

  const fetchContent = async () => {
    try {
      setLoading(true);
      const response = await EditorService.getTermsAndPrivacy();
      const data = response.data as { content: string }[];
      setContent({
        terms: data[0].content,
        privacy: data[1].content,
      });
    } catch (error) {
      console.error('Error al cargar el contenido:', error);
    } finally {
      setLoading(false);
    }
  };

  const saveContent = async (type: 'terms' | 'privacy') => {
    try {
      console.log(typeof content[type]); // Esto imprimirá "string"

      await EditorService.updateTermPrivacy(type, content[type]); // Enviarás el payload como esperado por el backend
      setEditing((prev) => ({
        ...prev,
        [type]: false,
      }));
    } catch (error) {
      console.error(`Error al guardar ${type}:`, error);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  const handleChange = (type: 'terms' | 'privacy') => (e: any) => {
    setContent((prev) => ({
      ...prev,
      [type]: e.target.value,
    }));
  };

  if (loading) {
    return (
      <Grid className='bg-white'>
        <Header />
        <Typography textAlign='center'>Cargando...</Typography>
      </Grid>
    );
  }

  const EditorContent = ({ type }: { type: 'terms' | 'privacy' }) => (
    <Box sx={{ mt: 3 }}>
      {editing[type] ? (
        <Editor
          value={content[type]}
          onChange={(event) =>
            setContent((prev) => ({
              ...prev,
              [type]: event.target.value,
            }))
          }
          containerProps={{
            style: {
              minHeight: '400px',
              border: '1px solid #ccc',
              borderRadius: '4px',
            },
          }}
          className='rsw-editor'
        />
      ) : (
        <div
          dangerouslySetInnerHTML={{ __html: content[type] }}
          style={{
            minHeight: '400px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '20px',
          }}
        />
      )}
      <Button
        variant='contained'
        color={editing[type] ? 'success' : 'primary'}
        sx={{ mt: 2 }}
        onClick={() => {
          if (editing[type]) {
            saveContent(type);
          } else {
            setEditing((prev) => ({
              ...prev,
              [type]: true,
            }));
          }
        }}
      >
        {editing[type] ? 'Guardar' : 'Editar'}
      </Button>
    </Box>
  );

  return (
    <Grid className='bg-white'>
      <Header />
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <EditorContent type='terms' />
      </Box>
    </Grid>
  );
};
